module.exports = __webpack_public_path__ + "static/img/turnShopMemberBg.32ace6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/turnShopMember/turnShopMemberBg.png
// module id = vfOl
// module chunks = 1